<template>
  <table v-if="items.length > 0" class="table table-sm table-striped table-responsive-md">
    <thead>
    <tr>
      <th>
        {{ $t('views.firm.list.firmname1') }}
      </th>
      <th>
        {{ $t('views.firm.list.nip') }}
      </th>
      <th>
        {{ $t('views.firm.list.address') }}
      </th>
    </tr>
    </thead>
    <tbody v-for="(item, index) in items" :key="index">
      <tr>
        <td>
          <router-link :to="{ name: 'FirmShow', params: { id: item['@id'] } }">
            {{ item.firmname1 }}
          </router-link>
        </td>
        <td>
          <span v-if="item.nip">{{ item.nip }}</span>
        </td>
        <td>
          <span v-if="item.fullAddress">{{ item.fullAddress }}</span>
        </td>
      </tr>
      <tr v-if="item.userDataEmployees.length > 0">
        <td colspan="3">
          <b>{{$t('views.firm.form.employees')}}:</b>
          <ul>
            <li v-for="employee in item.userDataEmployees" :key="employee['@id']">
              {{ employee.employee.fullName }}
              <span v-if="employee.employee.mobilePhone.length > 4">
                {{' - '}} <b>{{ $t('views.userdata.form.mobilePhone') + ': '}}</b> <phoneNumberLink :phoneNumber="employee.employee.mobilePhone"/>
              </span>
              <span v-if="employee.employee.userEmail">
                {{' - '}} <b>{{ $t('views.userdata.form.userEmail') + ': '}}</b> {{ employee.employee.userEmail}}
              </span>
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else>
    {{ $t('views.firm.list.noDepartments') }}
  </div>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'Departments',
  components: { PhoneNumberLink },
  props: ['idFirm'],

  data () {
    return {
      items: [],
      searchParams: {
        pagination: false,
        isCompany: 1,
        idHeadquarters: getId(this.idFirm)
      }
    }
  },

  watch: {
    '$route.path' () {
      this.$store.state.picker.current = this.$route.params.id
    }
  },

  mounted () {
    this.getPage()
  },

  methods: {
    async getPage () {
      const response = await new ApiService('user_datas', this.searchParams).getResults()
      this.items = response.items
    }
  }
}
</script>

<style scoped>

</style>
